<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12">
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section col-12 col-md-6 w-100">
                                <h2 class="heading-spacing--large pb-2">
                                    Gegevens BSO
                                </h2>
                                <div class="row">
                                    <div
                                        v-if="profileUpdate.logo"
                                        class="col-12 col-md-6 order-md-12"
                                    >
                                        <div
                                            class="profile-logo justify-content-center align-items-center"
                                        >
                                            <img
                                                :src="profileUpdate.logo.src"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 order-md-1">
                                        <text-input
                                            v-model="profileUpdate.Name"
                                            class="col-12"
                                            name="Naam organisatie"
                                            rules="required"
                                            @input="updateBSOInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.LRK"
                                            class="col-12"
                                            name="LRK-nummer"
                                            rules="required"
                                            @input="updateBSOInformation"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="form-section w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Adresgegevens organisatie
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="profileUpdate.Street"
                                        class="col-12 col-md-6"
                                        name="Straatnaam"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />
                                    <text-input
                                        v-model="profileUpdate.Zipcode"
                                        class="col-12 col-md-6"
                                        name="Postcode"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />

                                    <text-input
                                        v-model="profileUpdate.Housenumber"
                                        class="col-12 col-md-3"
                                        name="Huisnummer"
                                        type="number"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />

                                    <text-input
                                        v-model="
                                            profileUpdate.HousenumberAddition
                                        "
                                        class="col-12 col-md-3"
                                        name="Toevoeging"
                                        @input="updateBSOInformation"
                                    />

                                    <text-input
                                        v-model="profileUpdate.City"
                                        class="col-12 col-md-6"
                                        name="Plaats"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />
                                </div>
                            </div>

                            <div class="form-section w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Account en contactpersoon
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonFirstname
                                        "
                                        class="col-12 col-md-5"
                                        name="Voornaam"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonInsertion
                                        "
                                        class="col-12 col-md-2"
                                        name="Tussenvoegsel"
                                        @input="updateBSOInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonLastname
                                        "
                                        class="col-12 col-md-5"
                                        name="achternaam"
                                        rules="required"
                                        @input="updateBSOInformation"
                                    />

                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonPhone
                                        "
                                        class="col-12 col-md-6"
                                        name="Telefoonnummer"
                                        rules="required|digits:10"
                                        @input="updateBSOInformation"
                                    />
                                </div>
                            </div>

                            <editPassword
                                :profile="profileUpdate"
                                class="col-12 col-md-6 login-small"
                                @input="updateBSOInformation"
                            />
                            <dashboardMessage
                                :message="responseMsg"
                                :process="processing"
                            />
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
        <error-bar v-if="errorMessage" :error-message="errorMessage" />
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import editPassword from '@/components/form/edit-password';
import errorBar from '@/components/clientdashboard/dashboard-profile/error-bar';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        editPassword,
        errorBar,
        dashboardMessage
    },
    props: {
        profile: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            responseMsg: '',
            error: false,
            errorMessage: '',
            validationError: false,
            success: false,
            submitted: false,
            profileUpdate: {
                Id: '',
                Name: '',
                Lrk: '',
                BsoLogo: '',
                Street: '',
                Housenumber: '',
                HousenumberAddition: '',
                Zipcode: '',
                City: '',
                Phone: '',
                Email: '',
                Password: '',
                PasswordRepeat: '',
                ContactPersonFirstname: '',
                ContactPersonInsertion: '',
                ContactPersonLastname: '',
                ContactPersonPhone: '',
                ContactPersonEmail: ''
            },
            processing: false
        };
    },
    created() {
        this.profileUpdate = this.profile;
    },
    methods: {
        updateBSOInformation() {
            this.submitted = true;
            this.processing = true;
            this.responseMsg = '';
            const self = this;

            this.$refs.form.validate().then(success => {
                if (success) {
                    Axios.post('/clientdashboard/bso/update', {
                        profile: self.profileUpdate
                    })
                        .then(response => {
                            self.response = response;
                            self.processing = false;
                            self.submitted = false;
                            self.error = false;
                            if (response.data.success) {
                                self.responseMsg = response.data.successMsg;
                                self.profileUpdate.Password = null;
                                self.profileUpdate.PasswordRepeat = null;
                            } else {
                                self.errorMessage = response.data.errorMsg;
                            }
                            setTimeout(function() {
                                self.responseMsg = '';
                                self.errorMessage = '';
                            }, 5000);

                            return;
                        })
                        .catch(error => {
                            this.errorMessage =
                                error.response.data.ExceptionMessage;
                            setTimeout(function() {
                                self.errorMessage = '';
                            }, 5000);
                        })
                        .finally(() => {
                            self.processing = false;
                            setTimeout(function() {
                                self.responseMsg = '';
                            }, 3500);
                        });
                } else {
                    this.processing = false;
                    window.scrollTo(0, 0);
                    self.error = true;
                }
            });
        }
    }
};
</script>
